import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconKey } from '../../../../whitelabel/icon-key.enum';
import { ButtonComponent } from '../../../osp-ui/components/button/button/button.component';
import { IconComponent } from '../../../osp-ui/components/icon/icon/icon.component';
import { ToastComponent } from '../../../osp-ui/components/messages/toast/toast.component';
import { Message, ToastAction } from '../../../osp-ui/contract/message.contract';
import { FormatDateTimePipe } from '../../pipes/format-date-time.pipe';
import { IconPipe } from '../../pipes/icon.pipe';
import { ClickableDirective } from '../../directives/clickable.directive';

@Component({
  selector: 'osp-root-toast',
  standalone: true,
  imports: [
    ToastComponent,
    IconComponent,
    TranslateModule,
    CommonModule,
    IconPipe,
    FormatDateTimePipe,
    ButtonComponent,
    ClickableDirective,
  ],
  templateUrl: './root-toast.component.html',
  styleUrl: './root-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class RootToastComponent {
  @ViewChild('toast') toast!: ToastComponent;

  readonly IconKey = IconKey;

  protected dismiss(message: Message): void {
    const index = (this.toast.messages ?? []).findIndex(({ id }) => id === message.id);
    this.toast.messages?.splice(index, 1);
  }

  protected handleCloseKeyDown(event: KeyboardEvent, message: Message): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.dismiss(message);
    }
  }

  protected runAction(action: ToastAction, message: Message): void {
    action.callback();
    this.dismiss(message);
  }
}
